import DOMPurify from "dompurify";

const ALLOWED_IFRAME_HOSTS = ["www.youtube.com", "www.youtube-nocookie.com", "player.vimeo.com"];

DOMPurify.addHook("uponSanitizeElement", (node, data) => {
  if (data.tagName === "iframe") {
    const src = node.getAttribute("src") || "";
    let host = "";
    try { host = new URL(src).hostname; } catch (_) { host = ""; }
    if (!ALLOWED_IFRAME_HOSTS.includes(host)) node.parentNode?.removeChild(node);
  }
});

export function sanitizeArticle(html) {
  return DOMPurify.sanitize(html || "", {
    ADD_TAGS: ["iframe", "video", "source"],
    ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "controls", "playsinline", "preload", "poster", "target", "width", "height"],
  });
}
